module.exports = "<!-- Copyright (C) 2016 NooBaa -->\n\n<span class=\"highlight\">Hi, I reset your password:</span>\nAccount name: <span>{{accountName}}</span>\nNew temporary password: <span>{{password}}</span>\n";
